import { observable, action, makeObservable } from "mobx";
import { Address, IAddress } from "./Address";

export interface IAddressCollection {
    addresses: Address[];
}

export class AddressCollection implements IAddressCollection {
    @observable addresses = [] as Address[];

    constructor(addresses?: IAddress[]) {
        makeObservable(this);

        if (addresses !== undefined) {
            this.addresses = addresses.map(address => new Address(address));
        }
    }

    @action setAddresses(addresses: Address[]) {
        this.addresses = addresses;
    }

    @action.bound onAddressUpdated(data: { address: Address }) {
        try {
            const updatedAddress = data.address;
            if (updatedAddress) {
                const index = this.addresses.findIndex(address => address.id === updatedAddress.id);
                if (index === -1) {
                    this.addresses.push(updatedAddress);
                } else {
                    this.addresses[index] = updatedAddress;
                }
            }
        } catch (error) {
            if (typeof error === 'string') {
                throw new Error(error);
            }
        }
    }

    @action.bound onAddressDeleted(data: { address: Address }) {
        try {
            const deletedAddress = data.address;
            if (deletedAddress) {
                let newAddresses = [] as Address[];
                this.addresses.forEach(address => {
                    if (address.id !== deletedAddress.id) {
                        newAddresses.push(address);
                    }
                })
                this.addresses = newAddresses;
            }
        } catch (error) {
            if (typeof error === 'string') {
                throw new Error(error);
            }
        }
    }
}